import React from "react";
import "./updateStatusModal.scss";
import "./updateStatusModal.scss";
import UIModal from "../../../../shared/components/UIModal";
import { Activity } from "../../../../models/activity.model";

interface UpdateStatusModalProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
    loading: boolean;
    activity?:Activity
}

const UpdateStatusModal = (props: UpdateStatusModalProps) => {

    const {
        visible,
        onOk,
        onCancel,
        loading,
        activity
    } = props;

    return (
        <UIModal
            visible={visible}
            okText="Confirm"
            closable={false}
            onCancel={onCancel}
            onOk={onOk}
            loading={loading}
            className="update-status-modal"
        >
            <h2 className="title">Are you sure to change the status?</h2>
            <span className={`subtitle ${activity?.warningData?.warningType!="normal" && `inactive`}`}>
               {activity?.warningData?.message}
            </span>
        </UIModal>
    );
};

export default UpdateStatusModal;
